import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "utils";
import { useCSReportsFilters } from "./useCSReportsFilters";
import { defaultDateRange } from "./reportHelpers";
import { SummaryByTeacherTab } from "./SummaryByTeacherTab";
import { DosageTrendTab } from "./DosageTrendTab";
import { GroupCollabTrendTab } from "./GroupCollabTrendTab";
import { StudentCollabTrendTab } from "./StudentCollabTrendTab";
import { StandardsListTab } from "./StandardsListTab";
import { StudentProficiencyBucketsTab } from "./StudentProficiencyBucketsTab";

const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const Heading = styled.h2`
  color: ${colors.nightlyWoods900 || "#111827"};
  font-size: 22px;
  font-weight: 600;
  margin: 0;
`;

export const CSReports = () => {
  const filters = useCSReportsFilters();
  const initialRange = defaultDateRange();
  const [startDate, setStartDate] = useState(initialRange.startDate);
  const [endDate, setEndDate] = useState(initialRange.endDate);
  const [activeTab, setActiveTab] = useState("summary-by-teacher");

  return (
    <Page>
      <Heading>Customer Success Reports</Heading>
      <Tabs activeKey={activeTab} onSelect={setActiveTab} mountOnEnter unmountOnExit>
        <Tab eventKey="summary-by-teacher" title="Summary by Teacher">
          <div style={{ paddingTop: 16 }}>
            <SummaryByTeacherTab
              filters={filters}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
            />
          </div>
        </Tab>
        <Tab eventKey="dosage-trend" title="Dosage Trend">
          <div style={{ paddingTop: 16 }}>
            <DosageTrendTab
              filters={filters}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
            />
          </div>
        </Tab>
        <Tab eventKey="group-collab-trend" title="Group Collab Trend">
          <div style={{ paddingTop: 16 }}>
            <GroupCollabTrendTab
              filters={filters}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
            />
          </div>
        </Tab>
        <Tab eventKey="student-collab-trend" title="Student Collab Trend">
          <div style={{ paddingTop: 16 }}>
            <StudentCollabTrendTab
              filters={filters}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
            />
          </div>
        </Tab>
        <Tab eventKey="standards-list" title="Standards List">
          <div style={{ paddingTop: 16 }}>
            <StandardsListTab
              filters={filters}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
            />
          </div>
        </Tab>
        <Tab eventKey="student-proficiency-buckets" title="Student Proficiency Buckets">
          <div style={{ paddingTop: 16 }}>
            <StudentProficiencyBucketsTab
              filters={filters}
              startDate={startDate}
              endDate={endDate}
              onStartDateChange={setStartDate}
              onEndDateChange={setEndDate}
            />
          </div>
        </Tab>
      </Tabs>
    </Page>
  );
};
